import Constants from '../../../common/constants';

const imageFolder = `${Constants.IMAGE_FOLDER}dekiloknaller/`;

const title = "Holy Road - De Kiloknaller";
const description = "Zowel kolonisten als Palestijnen kopen hun kip bij Rami Levy, de goedkoopste supermarkt in de omgeving. Maar de prijsvechter staat wel in een nederzetting. De Joden hier dragen wapens, de Palestijnen niet.";
const featuredImage = `${imageFolder}dekiloknaller/omslag.jpg`;

export default [
    {
        type: "Meta",
        title: title,
        meta: [
            {"property": "og:title", "content": title},
            {"property": "og:url", "content": `${Constants.DOMAIN}${Constants.STORY_URL}dekiloknaller`},
            {"property": "description", "content": ""},
            {"property": "og:description", "content": description},
            {"property": "og:image", "content": featuredImage},
            {"property": "twitter:card", "content": `summary_large_image`},
            {"property": "twitter:title", "content": title},
            {"property": "twitter:description", "content": description},
            {"property": "twitter:image", "content": featuredImage},
        ]
    },
    {
        type: "Quote",
        quote: description,
    },
    {
        type: "Iframe",
        hideSpacer: true,
        url: "https://player.vimeo.com/video/216162876"
    },
    {
        type: "Paragraph",
        text: "Op de bezette Westelijke Jordaanoever is het Israëlisch-Palestijnse conflict overal zichtbaar. Maar bij supermarkt Rami Levy in de illegale Joodse nederzettingen van Gush Etzion vechten ze een heel andere strijd uit: een permanente prijzenoorlog. Op het hoogtepunt van deze strijd kostte een kilo kip minder dan één shekel (24 eurocent)."
    },
    {
        type: "Paragraph",
        text: "Ook al staat deze supermarkt naast een rotonde waar talloze aanslagen zijn gepleegd – kip is kip. In hun dorpen rondom deze nederzettingen kunnen Palestijnen goedkoop naar de kapper en een broodje falafel is ook niet duur, maar tegen de kiloknallers van Rami Levy kan niemand op."
    },
    {
        type: "Paragraph",
        text: "Op 19 november 2015 opende Mohammed Abdel Basset al-Kharoub bij de rotonde het vuur op stilstaande auto’s voor de rotonde terwijl zijn dorpsgenoten honderd meter verderop een kilo kip kochten te midden van gewapende Israëlische kolonisten. Die ook hun kip bij Rami Levy halen. Want die laat je niet zomaar liggen voor die prijs."
    },
    {
        type: "Paragraph",
        text: "Anders dan op veel andere plaatsen op de Westelijke Jordaanoever wonen Joden en Arabieren hier kriskras door elkaar heen. Sommige Palestijnen komen tot de conclusie dat je maar beter kunt proberen om samen te leven met de Joodse bezetters in plaats van hen te bestrijden. Schoorvoetend doen ze hun boodschappen bij de Joden, en ook de werknemers van Rami Levy zijn Palestijnen. Maar laat het hun dorpsgenoten niet horen."
    }
]


// WEBPACK FOOTER //
// ./src/data/nl/stories/story2.js